import { useState } from 'react';
import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const CONSENT_KEY = 'itcs-maps-consent';

export const mapsSearchUrl = (query) => `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(query)}`;

// Google Maps is only loaded after an explicit click (GDPR two-click solution).
export function GoogleMap({ query, zoom = 14, title, className = '', testid = 'google-map' }) {
  const { t, lp } = useLanguage();
  const [allowed, setAllowed] = useState(() => localStorage.getItem(CONSENT_KEY) === '1');
  const allow = () => {
    localStorage.setItem(CONSENT_KEY, '1');
    setAllowed(true);
  };

  return (
    <div className={`relative overflow-hidden rounded-2xl border border-slate-200 bg-slate-50 ${className}`} data-testid={testid}>
      {allowed ? (
        <iframe
          title={title}
          src={`https://maps.google.com/maps?q=${encodeURIComponent(query)}&z=${zoom}&output=embed`}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          className="absolute inset-0 w-full h-full border-0"
          data-testid={`${testid}-iframe`}
        />
      ) : (
        <div className="absolute inset-0 blueprint-bg flex flex-col items-center justify-center text-center p-8">
          <span className="w-14 h-14 rounded-full bg-[#066ce7] text-white flex items-center justify-center mb-5 shadow-lg shadow-blue-500/30">
            <MapPin className="w-6 h-6" aria-hidden="true" />
          </span>
          <p className="text-sm text-slate-600 max-w-sm mb-5">
            {t('map.consent')}{' '}
            <Link to={lp('/datenschutz')} className="text-[#066ce7] underline underline-offset-2">{t('map.privacy')}</Link>
          </p>
          <button type="button" onClick={allow} className="bg-[#066ce7] hover:bg-[#005bb5] text-white text-sm font-semibold px-5 py-2.5 rounded-lg transition-colors" data-testid={`${testid}-load`}>
            {t('map.load')}
          </button>
        </div>
      )}
    </div>
  );
}
